import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem 
} from '@mui/material';

/**
 * Component for session selection dropdown
 */
const SessionSelector = ({ sessions, selectedSession, onChange }) => {
  // Get the selected session ID (if any)
  const selectedSessionId = selectedSession?.id || '';
  
  return (
    <FormControl fullWidth>
      <InputLabel id="session-label">Sessie *</InputLabel>
      <Select
        labelId="session-label"
        value={selectedSessionId}
        onChange={(e) => {
          // Find the session object by ID and pass it to onChange
          const selected = sessions.find(session => session.id === e.target.value);
          onChange(selected);
        }}
        label="Sessie"
      >
        {sessions.map((session) => (
          <MenuItem key={session.id} value={session.id}>
            {session.name} ({new Date(session.start_time).toLocaleString()} - {new Date(session.end_time).toLocaleString()})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SessionSelector; 